import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import "bootstrap-icons/font/bootstrap-icons.css";
import { THEME_COLOR } from "./config/club";
import { CLUB_ID } from "./config/club";

import { useTheme } from "../src/context/ThemeContext";
export default function GoogleLogin() {
  const { loginGoogle, user, setMode } = useAuth();
  const navigate = useNavigate();

  // 🎨 DEFINE YOUR THEME COLOR HERE
  const themeColor = THEME_COLOR

  const { darkMode, setDarkMode } = useTheme();
  const loginWithGoogle = async () => {
    try {
      await loginGoogle();
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  useEffect(() => {
    if (!user) return;
    if (user.role === "queue_master" && user.clubs?.includes(CLUB_ID)) {
      setMode("admin");
      navigate("/admin", { replace: true });
      return;
    }
    navigate("/join", { replace: true });
  }, [user, navigate, setMode]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "var(--app-bg)",
        // Subtle mesh gradient using your theme color at 5% opacity
        backgroundImage: `radial-gradient(at 0% 0%, ${themeColor}10 0, transparent 50%), radial-gradient(at 100% 100%, ${themeColor}10 0, transparent 50%)`,
        padding: "20px"
      }}>

      <div className="card border-0 shadow-lg p-4 p-md-5 text-center"
        style={{
          maxWidth: "450px",
          borderRadius: "28px",
          backgroundColor: "var(--card-bg)",
          border: `1px solid var(--border-color)` // Subtle theme-colored border
        }}>

        <div className="mb-4">
          <div className="position-relative d-inline-block mb-4">
            {/* Glow effect behind logo */}
            <div className="position-absolute top-50 start-50 translate-middle"
              style={{
                width: "190px", height: "190px",
                backgroundColor: themeColor,
                filter: "blur(30px)", opacity: "100", zIndex: 0
              }}></div>

            <img
              src="/img/rrc.png"
              alt="Logo"
              className="position-relative img-fluid"
              style={{
                width: "180px", height: "180px",
                borderRadius: "22px", objectFit: "cover",
                zIndex: 1
              }}
            />
          </div>

          <h1 className="h3 fw-bold mt-2" style={{ color: "var(--text-color)", letterSpacing: "-0.5px" }}>
            RRC <span style={{ color: themeColor }}>Pickleball</span>
          </h1>
          <p className="text-muted small">Smarter match-making, faster games.</p>
        </div>

        <div className="mt-4">
          <button
            className="btn w-100 py-3 rounded-pill d-flex align-items-center justify-content-center gap-3 mb-3"
            onClick={loginWithGoogle}
            style={{
              backgroundColor: themeColor,
              color: "white",
              fontSize: "1rem",
              fontWeight: "600",
              boxShadow: `0 10px 20px ${themeColor}40`, // Theme-colored shadow
              transition: "all 0.3s ease",
              border: "none"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.filter = "brightness(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.filter = "brightness(1)";
            }}
          >
            <i className="bi bi-google"></i>
            Sign in with Google
          </button>

          <p className="text-muted" style={{ fontSize: "0.85rem" }}>
            Admin portal login
          </p>
          <br></br>
          <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
            <hr className="flex-grow-1 m-0 opacity-10" />
            <span className="small text-muted text-uppercase fw-bold tracking-widest" style={{ fontSize: '0.65rem' }}>Legal</span>
            <hr className="flex-grow-1 m-0 opacity-10" />
          </div>
          <div className="d-flex justify-content-center gap-3">
            <a className="text-decoration-none fw-bold" style={{ fontSize: "0.75rem", color: themeColor }} href="/privacy-policy.html" target="_blank">
              Privacy Policy
            </a>
            <span className="text-muted opacity-25">|</span>
            <a className="text-decoration-none fw-bold" style={{ fontSize: "0.75rem", color: themeColor }} href="/terms-of-service.html" target="_blank">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
      <button
        onClick={() => setDarkMode(!darkMode)}
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          border: "none",
          background: "var(--card-bg)",
          color: "var(--text-color)",
          borderRadius: "999px",
          padding: "8px 12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          cursor: "pointer"
        }}
      >
        {!darkMode ? "🌙 Dark Mode" : "☀️ Light Mode"}
      </button>
    </div>
  );
}